// extracted by css-extract-rspack-plugin
export default {"spaceMedium":"20px","wrapper":"bad-browser-notification__wrapper___ZqO5w"};